import React from 'react';
import { Card } from '../shared/Card';
interface ProfileScreenProps {
  navigateTo: (screen: string) => void;
  userName?: string;
}
export const ProfileScreen = ({
  navigateTo,
  userName = 'Fitness Friend'
}: ProfileScreenProps) => {
  return <div className="flex flex-col h-full min-h-screen bg-white pb-16" data-id="element-1241">
      <main className="flex-1 p-6 space-y-6 overflow-y-auto" data-id="element-1242">
        <div className="flex items-center mb-6" data-id="element-1243">
          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center text-blue-500 mr-4" data-id="element-1244">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1245">
              <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" data-id="element-1246"></path>
              <circle cx="12" cy="7" r="4" data-id="element-1247"></circle>
            </svg>
          </div>
          <div data-id="element-1248">
            <h2 className="text-xl font-bold" data-id="element-1249">{userName}</h2>
            <p className="text-gray-500" data-id="element-1250">Member since May 2023</p>
            <button className="text-blue-500 text-sm font-medium mt-1" data-id="element-1251">
              Edit Profile
            </button>
          </div>
        </div>
        <Card className="p-4" data-id="element-1252">
          <h2 className="text-lg font-medium mb-4" data-id="element-1253">Account Settings</h2>
          <div className="space-y-4" data-id="element-1254">
            <div className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-1255">
              <div data-id="element-1256">
                <h3 className="font-medium" data-id="element-1257">Personal Information</h3>
                <p className="text-sm text-gray-500" data-id="element-1258">
                  Update your personal details
                </p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400" data-id="element-1259">
                <polyline points="9 18 15 12 9 6" data-id="element-1260"></polyline>
              </svg>
            </div>
            <div className="flex justify-between items-center py-2 border-b border-gray-100 cursor-pointer" onClick={() => navigateTo('notifications')} data-id="element-1261">
              <div data-id="element-1262">
                <h3 className="font-medium" data-id="element-1263">Notifications</h3>
                <p className="text-sm text-gray-500" data-id="element-1264">
                  Manage your notification preferences
                </p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400" data-id="element-1265">
                <polyline points="9 18 15 12 9 6" data-id="element-1266"></polyline>
              </svg>
            </div>
            <div className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-1267">
              <div data-id="element-1268">
                <h3 className="font-medium" data-id="element-1269">Privacy & Security</h3>
                <p className="text-sm text-gray-500" data-id="element-1270">
                  Control your privacy settings
                </p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400" data-id="element-1271">
                <polyline points="9 18 15 12 9 6" data-id="element-1272"></polyline>
              </svg>
            </div>
            <div className="flex justify-between items-center py-2" data-id="element-1273">
              <div data-id="element-1274">
                <h3 className="font-medium" data-id="element-1275">Connected Accounts</h3>
                <p className="text-sm text-gray-500" data-id="element-1276">
                  Manage connected services
                </p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400" data-id="element-1277">
                <polyline points="9 18 15 12 9 6" data-id="element-1278"></polyline>
              </svg>
            </div>
          </div>
        </Card>
        <Card className="p-4" data-id="element-1279">
          <h2 className="text-lg font-medium mb-4" data-id="element-1280">Fitness Preferences</h2>
          <div className="space-y-4" data-id="element-1281">
            <div className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-1282">
              <div data-id="element-1283">
                <h3 className="font-medium" data-id="element-1284">Workout Preferences</h3>
                <p className="text-sm text-gray-500" data-id="element-1285">
                  Update your workout settings
                </p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400" data-id="element-1286">
                <polyline points="9 18 15 12 9 6" data-id="element-1287"></polyline>
              </svg>
            </div>
            <div className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-1288">
              <div data-id="element-1289">
                <h3 className="font-medium" data-id="element-1290">Goals & Targets</h3>
                <p className="text-sm text-gray-500" data-id="element-1291">
                  Set and manage your fitness goals
                </p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400" data-id="element-1292">
                <polyline points="9 18 15 12 9 6" data-id="element-1293"></polyline>
              </svg>
            </div>
            <div className="flex justify-between items-center py-2" data-id="element-1294">
              <div data-id="element-1295">
                <h3 className="font-medium" data-id="element-1296">Health Data</h3>
                <p className="text-sm text-gray-500" data-id="element-1297">
                  Manage your health information
                </p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400" data-id="element-1298">
                <polyline points="9 18 15 12 9 6" data-id="element-1299"></polyline>
              </svg>
            </div>
          </div>
        </Card>
        <div className="pt-4" data-id="element-1300">
          <button className="w-full py-3 text-red-500 font-medium" data-id="element-1301">
            Log Out
          </button>
        </div>
      </main>
    </div>;
};